import { Context, FC, ReactNode } from 'react'

import { config } from '@/config'
import { AuthStrategy } from '@/lib/auth/strategy'

import { UserContext as Auth0UserContext, UserProvider as Auth0UserProvider } from './auth0/user-context'
import { UserContext as CustomUserContext, UserProvider as CustomUserProvider } from './custom/user-context'
import { UserContext as FronteggUserContext, UserProvider as FronteggUserProvider } from './frontegg/user-context'
import type { UserContextValue } from './types'

// eslint-disable-next-line import/no-mutable-exports -- Export based on config
let UserProvider: FC<{ children: ReactNode }>

// eslint-disable-next-line import/no-mutable-exports -- Export based on config
let UserContext: Context<UserContextValue | undefined>

switch (config.auth.strategy) {
	case AuthStrategy.CUSTOM:
	case AuthStrategy.FRONTEGG_CUSTOM:
		UserContext = CustomUserContext
		UserProvider = CustomUserProvider
		break
	case AuthStrategy.AUTH0:
		UserContext = Auth0UserContext
		UserProvider = Auth0UserProvider
		break
	case AuthStrategy.FRONTEGG:
		UserContext = FronteggUserContext
		UserProvider = FronteggUserProvider
		break
	default:
		throw new Error('Invalid auth strategy')
}

export { UserProvider, UserContext }
